<template>
  <div
    class="navigation shadow-lvl-2"
    :class="isOpen ? 'isOpen' : 'isClose'"
    @mouseleave="closeMenu"
    @mouseover="openMenu"
  >
    <NavigationLogo :isOpen="isOpen" :logo="getNavigationData.logo" />
    <nav class="navigation--main">
      <ul>
        <NavigationItem
          v-for="(item, key) in getNavigationData.primary_button_area"
          :key="`${key}-${item.name}`"
          :item="item"
          :isOpen="isOpen"
        />
        <div class="navigation--main__extra">
          <NavigationExtraBlock
            :isOpen="isOpen"
            :extraBlock="getNavigationData.fast_action_button_area"
          />
        </div>
        <div class="navigation--main__bottom">
          <NavigationItem
            v-for="(item, key) in getNavigationData.calls_area"
            :key="`${key}-${item.name}`"
            :item="item"
            :isOpen="isOpen"
          />
          <NavigationItem
            v-for="(item, key) in getNavigationData.service_button_area"
            :key="`${key}-${item.name}`"
            :item="item"
            :isOpen="isOpen"
          />
          <div
            class="navigation--main__profile"
            v-for="(item, key) in getNavigationData.profile_button_area"
            :key="key"
          >
            <NavigationProfile :isOpen="isOpen" :profile="item" />
          </div>
        </div>
      </ul>
    </nav>
  </div>
</template>
<script>
import { store } from '@/store';
import NavigationLogo from 'Elements/NavigationBar/NavigationLogo';
import NavigationItem from 'Elements/NavigationBar/NavigationItem';
import NavigationExtraBlock from 'Elements/NavigationBar/NavigationExtraBlock';
import NavigationProfile from 'Elements/NavigationBar/NavigationProfile';
export default {
  data() {
    return {
      isOpen: false
    };
  },
  async mounted() {
    await store.dispatch('navbar/getNavigationData');

    if (
      this.getNavigationData.calls_area?.length &&
      !localStorage.getItem('sessionId')
    ) {
      if (this.$cookie.get('UNIQUE_SESS_KEY'))
        localStorage.setItem('sessionId', this.$cookie.get('UNIQUE_SESS_KEY'));
    } else if (
      !this.getNavigationData.calls_area?.length &&
      localStorage.getItem('sessionId')
    ) {
      localStorage.removeItem('sessionId');
    }

    if (this.getNavigationData?.telephony_init?.tfApiBaseURL) {
      await store.dispatch(
        'common/initTelephony',
        this.getNavigationData.telephony_init.tfApiBaseURL
      );
    }
  },
  methods: {
    openMenu() {
      if (this.isOpen) return;
      this.isOpen = true;
    },
    closeMenu() {
      this.isOpen = false;
    },
    exitUser() {
      this.$store.dispatch('auth/exitUser');
    }
  },
  computed: {
    getNavigationData() {
      return store.state.navbar.navigationData;
    }
  },
  components: {
    NavigationLogo,
    NavigationItem,
    NavigationExtraBlock,
    NavigationProfile
  }
};
</script>
<style lang="scss" scoped>
.isOpen {
  width: 320px;
}

.isClose {
  width: 72px;
}

.navigation::-webkit-scrollbar {
  width: 4px;
}

.navigation::-webkit-scrollbar-thumb {
  width: 4px;
  border-radius: 4px;
  background: $grey16;
}

.navigation::-webkit-scrollbar-button {
  display: none;
}

.navigation {
  display: flex;
  flex-direction: column;
  position: fixed;
  height: 100%;
  padding: 28px 16px 28px 0;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: 10;
  transition: all 0.2s;
  overflow: hidden;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 24px;
  color: $grey40;
  background-color: $white;
  box-sizing: border-box;

  &--main {
    height: 100%;
    ul {
      display: flex;
      flex-direction: column;
      height: 100%;
    }
  }
}

@media (min-height: 831px) {
  .navigation {
    display: flex;
    &--main {
      &__bottom {
        margin-top: auto;
      }
    }
  }
}

@media (max-height: 830px) {
  .navigation {
    display: flex;
    overflow-y: auto;

    &--main {
      &__extra {
        order: 1;
        padding-bottom: 16px;
        background-color: $white;
        position: fixed;
        bottom: 0;
        display: flex;
        z-index: 12000;
        padding-top: 20px;
        background: linear-gradient(
          0deg,
          #ffffff 93.33%,
          rgba(255, 255, 255, 0) 100%
        );
      }
    }
  }
}
</style>
